import React from 'react';
import AssetImage from '../../../Components/Assets/Image';
import { useMyPerks, isPendingPerk, perkTitle } from '../../../Data/Perks';
import { classNames, useRedirect } from '../../../Services/helpers';
import Icon from '../../../Components/Icons/Icon';

const Perks = () => {
    const { perks, isLoading } = useMyPerks(true);
    const { go } = useRedirect();
    const pendingPerks = (perks ?? []).filter(isPendingPerk);

    if (isLoading || pendingPerks.length === 0) {
        return null;
    }

    return <>
        {pendingPerks.map((perk) => (
            <PerkCard
                key={perk.id}
                perk={perk}
                onClick={() => go(`/perks/${perk.id}`)}
            />
        ))}
    </>;
};

const PerkCard = ({ perk, onClick }) => {
    return <button
        type="button"
        onClick={onClick}
        className={classNames(
            'w-full text-left rounded-xl my-3 p-4 surface-4 surface-outline',
            'flex flex-row items-center gap-4 cursor-pointer',
        )}
    >
        <div className="shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-white/20">
            {perk.imageAssetId ? (
                <AssetImage
                    assetId={perk.imageAssetId}
                    dimensions="128x128"
                    className="w-full h-full object-cover"
                    alt={perkTitle(perk)}
                />
            ) : (
                <div className="w-full h-full flex items-center justify-center">
                    <Icon icon="Gift" size="2x" />
                </div>
            )}
        </div>
        <div className="grow min-w-0">
            <p className="font-bold text-base">{perkTitle(perk)}</p>
            <p className="text-sm text-white/90 mt-1 line-clamp-2">
                {perk.description || 'You have a perk waiting for you.'}
            </p>
        </div>
        <Icon icon="RightChevron" size="1x" className="shrink-0 opacity-80" />
    </button>;
};

export default Perks;
